<section id="services" >
    <div class="container text-center">
        <h1 class="title">What I Provide?</h1>
        <div class="row text-center" data-aos="fade-left">
            <div class="col-md-6 services">
                <img src="../../assets/_Pngtree_modern_flat_design_concept_of_5332909-removebg-preview.png" class="service-img" alt="">
                <h3>Web Development</h3>
                <p>         
The responsibilities of a Front-Back End developer encompass defining the layout and composition of web pages, ensuring that the web design is tailored for optimal performance on smartphones, and overseeing the server side, including the management of collected data.</p>
            </div>
            <div class="col-md-6 services">
                <img src="../../assets/—Pngtree—computer and web design elements_4037624.png" class="service-img" alt="">
                <h3>Design</h3>
                <p class=""> 
                    Achieving a harmonious blend of functional and visually appealing design through the creation of seamless UI wireframes and prototypes is a key aspect of the design services I offer.
                    </p>
            </div>
        </div>
    </div>
    </section>
    
    